import ReactDOM from "react-dom";

import "./index.css";
import { ConfigContextProvider, EventsContextProvider } from "./context";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <ConfigContextProvider>
      <EventsContextProvider>
        <App />
      </EventsContextProvider>
    </ConfigContextProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
